import _Abstract from "system/abstract";

export default class Component_InputValidatorv2 extends _Abstract {
  constructor(el, options) {
    super(el, $.extend(true, {}, options), "component");
    this.EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.bindEvents();
    $("select.c-label-select__fields")
      .selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
        onChange: function () {
          $(".selectric-c-label-select__fields").removeClass("is-invalid");
        },
      })
      .on("selectric-before-open", function () {
        if ($(".selectric-c-label-select__fields").hasClass("is-invalid")) {
          $(".selectric-c-label-select__fields").removeClass("is-invalid");
        }
      });
  }

  bindEvents() {
    this.$el.find("input").blur((e) => this.onInputBlurred(e));
    this.$el.find("input").keyup((e) => this.onInputKeyUp(e));
    this.$el.find("textarea").blur((e) => this.onTextareBlurred(e));
    this.$el.find("textarea").keyup((e) => this.onTextareKeyUp(e));
    if (typeof this.options.submit_button_selector !== "undefined") {
      this.$el
        .find(this.options.submit_button_selector)
        .click((e) => this.onSubmitButtonClicked(e));
    }
  }

  onInputBlurred(e) {
    var $input = $(e.currentTarget);
    this.validateElement($input);
  }

  onInputKeyDown(e) {
    var $input = $(e.currentTarget);
    return this.forceCharacterLimits($input);
  }

  onInputKeyUp(e) {
    var $input = $(e.currentTarget);
    this.validateElement($input);
  }

  onTextareKeyUp(e) {
    var $input = $(e.currentTarget);
    this.validateElement($input);
  }

  onTextareBlurred(e) {
    var $input = $(e.currentTarget);
    this.validateElement($input);
  }

  forceCharacterLimits($element) {
    var characterLimit = $element.data("character-limit");
    if (!characterLimit) {
      return true;
    }

    var elementValue = $element.val();
    if (elementValue.length > characterLimit) {
      return false;
    }
    return true;
  }

  validateTextarea($element) {
    if ($element.val()) {
      $element.removeClass("invalid-input");
      $element.closest(".c-label-input-ctn").removeClass("invalid-input");
      return true;
    } else {
      $element.addClass("invalid-input");
      $element.closest(".c-label-input-ctn").addClass("invalid-input");
      return false;
    }
  }

  validateElement($element) {
    if (!$element.closest(".c-label-input-ctn").hasClass("required")) {
      return;
    }

    var inputType = $element.attr("type");
    var bValidInput = $element.val();
    if (inputType.toLowerCase() === "email") {
      bValidInput = this.EMAIL_REGULAR_EXPRESSION.test($element.val());
    }

    if ($element.data("match")) {
      var matchSelector = $element.data("match");
      var $elementToMatch = $(matchSelector);
      if ($elementToMatch.length) {
        if ($element.val() !== $elementToMatch.val()) {
          bValidInput = false;
        }
      } else {
        console.log(
          "input-validator: Failed to find matching element to compare data!"
        );
      }
    }

    if (bValidInput) {
      $(".-error").html("Comments Field<span>*</span>");
      $element.removeClass("invalid-input");
      $element.closest(".c-label-input-ctn").removeClass("invalid-input");
      return true;
    } else {
      $(".-error").html("Comments<span>*</span>");
      $element.addClass("invalid-input");
      $element.closest(".c-label-input-ctn").addClass("invalid-input");
      return false;
    }
  }

  onErrorScrollTop() {
    $("html,body").animate(
      {
        scrollTop: $(".-scrolltop").offset().top - 30,
      },
      "fast"
    );
  }

  formValidation(bAllValidated, e) {
    var context = this;
    if (bAllValidated) {
      context.$el.find(".form-is-valid").removeClass("-hide");
      context.$el.find(".form-is-invalid").addClass("-hide");
      // Change checkbox value when checked
      var $signMeUp = $('input[name="subscribe"]');
      if ($signMeUp.prop("checked")) {
        $(".js-form-stream-val").attr("value", 1);
      } else {
        $(".js-form-stream-val").attr("value", 0);
      }
      var htmlLoader =
        "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
      $(".cta-input-sugarform--send-btn").after(htmlLoader);
      $(".cta-input-sugarform--send-btn").css("visibility", "hidden");

      if (
        window.location.hostname === "furnware-static.uniondigital.co.nz" ||
        window.location.hostname === "localhost"
      ) {
        return;
      }
      if($(e.currentTarget).hasClass( "stem-submit-btn" )) {
        context.setCookie("stemlearningpopup", "clicked", 100000)
      }
      $("#aspnetForm").attr(
        "action",
        $(".cta-input-form").data("sugar-market-post-url")
      );
      $("#aspnetForm").unbind("submit").removeAttr("onsubmit");
      $("#aspnetForm").submit();
    } else {
      context.$el.find(".form-is-valid").addClass("-hide");
      context.$el.find(".form-is-invalid").removeClass("-hide");
      grecaptcha.reset();
      context.onErrorScrollTop();
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  recaptchaValidation(context,bAllValidated,e) {
    $.ajax({
      type: "GET",
      url: `/WebApi/ReCaptchaApi/VerifyReCaptcha?reCaptchaResponse=${grecaptcha.getResponse()}`,
      error: function (response) {
        bAllValidated = false;
        $(".g-recaptcha__errormsg").addClass("-hide");
        context.formValidation(bAllValidated, e);
      },
      success: function (response) {
        if (response == true) {
          $(".g-recaptcha__errormsg").addClass("-hide");
          context.formValidation(bAllValidated, e);
        } else {
          bAllValidated = false;
          $(".g-recaptcha__errormsg").removeClass("-hide");
          context.formValidation(bAllValidated, e);
        }
      },
    });
  }

  onSubmitButtonClicked(e) {
    var context = this;
    var bAllValidated = true;
    var dropdownValidated = true;
    var textareaValidated = true;
    if ( $(".cta-input-form").data("sugar-market-form") == "contact") {
      if ($(".c-label-select__fields").val() == "-1") {
        $(".selectric-c-label-select__fields").addClass("is-invalid");
        dropdownValidated = false;
      }
      if (this.$el.find(".required textarea").length > 0) {
        textareaValidated = this.validateTextarea(
          this.$el.find(".required textarea")
        );
      }
      this.$el.find(".required input").each(function () {
        var $input = $(this);
        if (!context.validateElement($input)) {
          bAllValidated = false;
        }
      });
      if (bAllValidated && textareaValidated && dropdownValidated) {
        this.$el.find(".form-is-valid").removeClass("-hide");
        this.$el.find(".form-is-invalid").addClass("-hide");
      } else {
        this.$el.find(".form-is-valid").addClass("-hide");
        this.$el.find(".form-is-invalid").removeClass("-hide");
        this.onErrorScrollTop();
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      context.recaptchaValidation(context,bAllValidated,e);
    } else {
      if($(".c-label-select__fields").length) {
        if ($(".c-label-select__fields").val() == "-1") {
          $(".selectric-c-label-select__fields").addClass("is-invalid");
          bAllValidated = false;
        }
      }
      this.$el.find(".required input").each(function () {
        var $input = $(this);
        if (!context.validateElement($input)) {
          bAllValidated = false;
        }
      });
      e.preventDefault();
      e.stopImmediatePropagation();
      context.recaptchaValidation(context,bAllValidated,e);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./components/input-validator-v2.js
 **/